import HomeLayout from '@/layouts/Home.vue'
import Certifications from './views/Certifications.vue'
export const certificationRoutes = [
  {
    path: '/certifications',
    name: 'certifications',
    component: Certifications,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['employee', 'supervisor'],
    },
  },
]
